import Parse from "parse"

/**
 * The user as stored in a lot event (`Lots.events[].user`).
 *
 * Parse's `toJSON()` on the current user also carries its `sessionToken`: written into a Lot, it
 * let anyone who reads lots act as that user. Keep only what the event history reads.
 */
export const toLotEventUser = (user) => {
  if (!user) return null

  return {
    objectId: user.id,
    username: user.get("username"),
    email: user.get("email")
  }
}

export const getLotEventUser = () => toLotEventUser(Parse.User.current())
